import React, { useEffect, useRef, useState } from "react";
import CompanyPageLayout from "./CompanyPageLayout";
import "./Contact.css";

const APPLICATION_EMAIL = "enterprise@weavevo.com";

const INTEREST_AREAS = [
  "Engineering",
  "AI & Cloud",
  "Product & Design",
  "Business & Partnerships",
  "Other",
];

export default function CareersPage() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    currentRole: "",
    location: "",
    interest: "Engineering",
    linkedin: "",
    message: "",
  });
  const [interestOpen, setInterestOpen] = useState(false);
  const interestSelectRef = useRef(null);

  const updateField = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (!interestSelectRef.current?.contains(event.target)) setInterestOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setInterestOpen(false);
    };

    document.addEventListener("mousedown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  const selectInterest = (interest) => {
    setForm((current) => ({ ...current, interest }));
    setInterestOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const subject = `Careers / Join Us — ${form.interest}`;
    const body = [
      `Name: ${form.name.trim()}`,
      `Email: ${form.email.trim()}`,
      `Current Role: ${form.currentRole.trim()}`,
      `Location: ${form.location.trim()}`,
      `Area of Interest: ${form.interest}`,
      `LinkedIn / Portfolio: ${form.linkedin.trim()}`,
      "",
      form.message.trim(),
    ].join("\n");

    window.location.href = `mailto:${APPLICATION_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <CompanyPageLayout pageTitle="Careers / Join Us" title="Careers / Join Us">
      <div className="wv-contactWrap wv-careersWrap">
        <section className="wv-contactInfo" aria-label="Careers at Weavevo">
          <div className="wv-contactInfoGlow" aria-hidden="true" />
          <div className="wv-contactInfoTop">
            <div className="wv-contactIcon" aria-hidden="true">
              <span />
              <span />
              <span />
            </div>
            <h2>Building the Future of Collaborative Living Media</h2>
            <p className="wv-careersLead">A multidisciplinary team of engineers, storytellers, and product builders designing perpetual video architecture.</p>
          </div>

          <a className="wv-contactEmail" href={`mailto:${APPLICATION_EMAIL}`}>
            <span className="wv-contactEmailIcon" aria-hidden="true">@</span>
            <span>{APPLICATION_EMAIL}</span>
            <span className="wv-contactEmailArrow" aria-hidden="true">↗</span>
          </a>
        </section>

        <form className="wv-contactForm wv-careersForm" onSubmit={handleSubmit}>
          <div className="wv-contactGrid">
            <label className="wv-contactField">
              <span>Name</span>
              <input type="text" name="name" value={form.name} onChange={updateField} autoComplete="name" required />
            </label>

            <label className="wv-contactField">
              <span>Email</span>
              <input type="email" name="email" value={form.email} onChange={updateField} autoComplete="email" required />
            </label>

            <label className="wv-contactField">
              <span>Current Role</span>
              <input type="text" name="currentRole" value={form.currentRole} onChange={updateField} autoComplete="organization-title" />
            </label>

            <label className="wv-contactField">
              <span>Location</span>
              <input type="text" name="location" value={form.location} onChange={updateField} autoComplete="address-level2" />
            </label>
          </div>

          <div className="wv-contactType">
            <span className="wv-contactTypeLabel">Area of Interest</span>
            <div ref={interestSelectRef} className={`wv-contactSelect${interestOpen ? " is-open" : ""}`}>
              <button
                type="button"
                className="wv-contactSelectTrigger"
                aria-haspopup="listbox"
                aria-expanded={interestOpen}
                onClick={() => setInterestOpen((open) => !open)}
              >
                <span>{form.interest}</span>
                <span className="wv-contactSelectChevron" aria-hidden="true" />
              </button>

              {interestOpen ? (
                <div className="wv-contactSelectMenu" role="listbox" aria-label="Area of Interest">
                  {INTEREST_AREAS.map((interest) => {
                    const selected = form.interest === interest;
                    return (
                      <button
                        key={interest}
                        type="button"
                        role="option"
                        aria-selected={selected}
                        className={`wv-contactSelectOption${selected ? " is-selected" : ""}`}
                        onClick={() => selectInterest(interest)}
                      >
                        <span>{interest}</span>
                        {selected ? <span className="wv-contactSelectCheck" aria-hidden="true">✓</span> : null}
                      </button>
                    );
                  })}
                </div>
              ) : null}
            </div>
          </div>

          <label className="wv-contactField">
            <span>LinkedIn / Portfolio</span>
            <input type="url" name="linkedin" value={form.linkedin} onChange={updateField} autoComplete="url" />
          </label>

          <label className="wv-contactField">
            <span>Message</span>
            <textarea name="message" value={form.message} onChange={updateField} rows="4" />
          </label>

          <div className="wv-contactActions">
            <button type="submit" className="wv-contactSubmit">
              <span>Send application</span>
              <span className="wv-contactSubmitArrow" aria-hidden="true">↗</span>
            </button>
          </div>
        </form>
      </div>
    </CompanyPageLayout>
  );
}
